import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export const Footer = () => (
  <footer className="bg-[#FBF7EE] border-t border-[#211B10]/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-24">
      <Reveal className="mb-20">
        <h2 className="font-display tracking-tighter text-3xl md:text-5xl max-w-3xl leading-tight mb-8">
          Satu keputusan hari ini bisa menjadi titik balik tahun ini.
        </h2>
        <a
          data-testid="footer-cta-button"
          href="#produk"
          className="inline-flex items-center gap-3 bg-[#A67C1E] text-[#FBF7EE] font-medium text-sm uppercase tracking-[0.15em] px-8 py-4 hover:bg-[#211B10] hover:-translate-y-1 transition-[background-color,transform] duration-300"
        >
          Mulai Sekarang
          <ArrowUpRight className="w-4 h-4" />
        </a>
      </Reveal>
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 border-t border-[#211B10]/10 pt-10">
        <div>
          <span className="inline-flex items-center gap-3 mb-4">
            <img src="/nalura-logo.jpg" alt="Logo NALURA" className="w-12 h-12 object-contain mix-blend-multiply" />
            <span>
              <span className="font-display text-2xl tracking-tight text-[#211B10] leading-none block">NALURA<span className="text-[#A67C1E]">.</span></span>
              <span className="font-mono text-[8px] uppercase tracking-[0.28em] text-[#A67C1E] block mt-1">Good Mind Good Life</span>
            </span>
          </span>
          <p className="text-xs text-[#211B10]/60 max-w-md leading-relaxed">
            Penafian: Kami adalah mitra affiliate resmi. Sebagian tautan di halaman ini adalah tautan affiliate — kami dapat menerima komisi dari pembelian yang Anda lakukan, tanpa biaya tambahan apa pun bagi Anda.
          </p>
        </div>
        <div className="flex flex-col md:items-end gap-4">
          <div className="flex items-center flex-wrap gap-x-6 gap-y-3 font-mono text-[10px] uppercase tracking-[0.2em] md:justify-end">
            <Link to="/gratis" data-testid="footer-gratis-link" className="text-[#211B10]/60 hover:text-[#A67C1E] transition-colors">Panduan Gratis</Link>
            <Link to="/artikel" data-testid="footer-artikel-link" className="text-[#211B10]/60 hover:text-[#A67C1E] transition-colors">Artikel</Link>
            <Link to="/kontak" data-testid="footer-contact-link" className="text-[#211B10]/60 hover:text-[#A67C1E] transition-colors">Kontak</Link>
            <Link to="/kebijakan-privasi" data-testid="footer-privacy-link" className="text-[#211B10]/60 hover:text-[#A67C1E] transition-colors">Kebijakan Privasi</Link>
            <Link to="/syarat-ketentuan" data-testid="footer-terms-link" className="text-[#211B10]/60 hover:text-[#A67C1E] transition-colors">Syarat & Ketentuan</Link>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#211B10]/55">
            © {new Date().getFullYear()} NALURA — Good Mind Good Life
          </p>
        </div>
      </div>
    </div>
  </footer>
);
